module.exports = __webpack_public_path__ + "img/bg.8f4d9a47.png";